import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ro from "./locales/ro.json";
import en from "./locales/en.json";
import de from "./locales/de.json";
import hu from "./locales/hu.json";
// Holidays 2027 landing page copy — English master. Add ./holidays/{ro,de,hu}.json
// when approved translations exist; missing languages fall back to English.
import holidaysEn from "./holidays/en.json";

const HOLIDAYS = { en: holidaysEn, ro: null, de: null, hu: null };
const withHolidays = (base, lang) => (HOLIDAYS[lang] ? { ...base, holidays: HOLIDAYS[lang] } : base);
// Language actually used for the holidays page copy (falls back to EN until translated).
export const holidaysLang = (lang) => (HOLIDAYS[lang] ? lang : "en");

export const SUPPORTED_LANGS = ["ro", "en", "de", "hu"];
export const DEFAULT_LANG = "ro";

// Detect language from URL first segment (e.g., /en/experiente → 'en')
export function detectLangFromPath(pathname = window.location.pathname) {
  const seg = pathname.split("/").filter(Boolean)[0];
  return SUPPORTED_LANGS.includes(seg) ? seg : DEFAULT_LANG;
}

// Strip the language prefix from a path — used to reroute.
// "/en/experiente/foo" → "/experiente/foo"
export function stripLangPrefix(pathname) {
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length && SUPPORTED_LANGS.includes(parts[0]) && parts[0] !== DEFAULT_LANG) {
    return "/" + parts.slice(1).join("/");
  }
  return pathname === "" ? "/" : pathname;
}

// Build a localized path.
// localizedPath("/experiente", "en") → "/en/experiente"
// localizedPath("/experiente", "ro") → "/experiente"
export function localizedPath(path, lang) {
  const l = SUPPORTED_LANGS.includes(lang) ? lang : DEFAULT_LANG;
  const p = path.startsWith("/") ? path : "/" + path;
  if (l === DEFAULT_LANG) return p;
  // avoid double prefix
  const parts = p.split("/").filter(Boolean);
  if (parts.length && SUPPORTED_LANGS.includes(parts[0])) {
    return "/" + [l, ...parts.slice(1)].join("/");
  }
  return "/" + l + (p === "/" ? "" : p);
}

// Initialize i18next.
i18n
  .use(initReactI18next)
  .init({
    resources: {
      ro: { translation: withHolidays(ro, "ro") },
      en: { translation: withHolidays(en, "en") },
      de: { translation: withHolidays(de, "de") },
      hu: { translation: withHolidays(hu, "hu") },
    },
    lng: (() => {
      // Priority: URL > localStorage > browser > default
      try {
        const fromPath = detectLangFromPath();
        if (fromPath) return fromPath;
        const stored = localStorage.getItem("apuseni_lang");
        if (stored && SUPPORTED_LANGS.includes(stored)) return stored;
      } catch { /* noop */ }
      return DEFAULT_LANG;
    })(),
    fallbackLng: [DEFAULT_LANG, "en"],
    interpolation: { escapeValue: false },
    returnNull: false,
  });

export default i18n;
